import { render, staticRenderFns } from "./Emoji.vue?vue&type=template&id=36243ed9&scoped=true&"
import script from "./Emoji.vue?vue&type=script&lang=js&"
export * from "./Emoji.vue?vue&type=script&lang=js&"
import style0 from "./Emoji.vue?vue&type=style&index=0&id=36243ed9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36243ed9",
  null
  
)

component.options.__file = "Emoji.vue"
export default component.exports